export const SOUND_CLOUD_PLAYLIST_FETCH = 'SOUND_CLOUD_PLAYLIST_FETCH';
export const SOUND_CLOUD_STREAM_CLOSE = 'SOUND_CLOUD_STREAM_CLOSE';
export const SOUND_CLOUD_STREAM_PAUSE = 'SOUND_CLOUD_STREAM_PAUSE';
export const SOUND_CLOUD_STREAM_RESUME = 'SOUND_CLOUD_STREAM_RESUME';
export const SOUND_CLOUD_STREAM_START = 'SOUND_CLOUD_STREAM_START';
